import React from "react"
import {useSelector} from "react-redux"
import { Switch, Route, Redirect } from "react-router-dom"

import MainLayout from "./layouts/MainLayout"

import Authentication from './containers/Authentication/'
import Coupons from "./containers/Coupons"
import CouponOrders from "./containers/CouponOrders"
import EmployeeRewards from "./containers/EmployeeRewards"
import ProductRates from "./containers/ProductRates"
import Error404 from './containers/ErrorsPages/Error404'
import Employees from "./containers/Employees"
import Incentives from "./containers/Incentives"
import OrderInvoices from "./containers/OrderInvoices"
import Rewards from "./containers/Rewards"
import Reports from "./containers/Reports"
import Referrals from "./containers/Referrals"
import ReferralOrders from "./containers/ReferralOrders"
import Settings from "./containers/Settings"

export default function App() {	
	const token = useSelector(state => state.auth.token)
	
	return (
		<React.Fragment>			
			<Switch>
				<Redirect exact path="/" to="/employees" />

				<Route path="/auth" component={Authentication} />
				{!token && <Redirect to="/auth/login" />}

				<MainLayout>
					<Route path="/employees" component={Employees} />
					<Route path="/coupons" component={Coupons} />
					<Route path="/coupon_orders" component={CouponOrders} />
					<Route path="/order_invoices" component={OrderInvoices} />
					<Route path="/incentives" component={Incentives} />
					<Route path="/referrals" component={Referrals} />
					<Route path="/referral_orders" component={ReferralOrders} />
					<Route path="/rewards" component={Rewards} />
					<Route path="/employee_rewards" component={EmployeeRewards} />
					<Route path="/product_rates" component={ProductRates} />
					<Route path="/settings" component={Settings} />
					<Route path="/reports" component={Reports} />
					
					<Route path="/404" component={Error404} />
				</MainLayout>
			</Switch>
		</React.Fragment>
	);	
}